import styled from 'styled-components';

export const Message = styled.h5`
  margin: 40px 0px 80px;
  color: var(--chakra-colors-brand-primary);
  font-style: italic;
  font-weight: 700;
`;
